<template>
  <!-- SK4-H (KONSOL-V4 K8): konsol bildirim zili — panel AdminLayout zilinin sade karşılığı
       (Sparqon birleşik rozeti yok; sağlayıcının Sparqon'u konsolda ayrı). Kişisel Bildirim tablosu,
       aynı uçlar: GetOkunmamisBildirimler / GetBildirimler / SetBildirimOkundu / SetTumBildirimlerOkundu.
       Yönlendirme bildirimRotasi'nin konsol dalından (çağrı → Destek masası). -->
  <div class="relative">
    <button type="button" class="sk-ikon-dugme relative" :aria-label="'Bildirimler' + (okunmamis.length ? ' (' + okunmamis.length + ' okunmamış)' : '')"
      aria-haspopup="true" @click="ac">
      <i class="pi pi-bell"></i>
      <span v-if="okunmamis.length" class="zil-sayi">{{ okunmamis.length > 99 ? "99+" : okunmamis.length }}</span>
    </button>
    <Popover ref="pop" @show="tumunuYukle">
      <div class="w-[22rem] max-w-[calc(100vw-2rem)]">
        <div class="flex items-center justify-between gap-2 px-1 pb-2 border-b border-gray-200 dark:border-gray-700">
          <div class="flex gap-1">
            <button type="button" class="zil-sekme" :class="{ 'zil-sekme-aktif': sekme === 'okunmamis' }" @click="sekme = 'okunmamis'">
              Okunmamış ({{ okunmamis.length }})
            </button>
            <button type="button" class="zil-sekme" :class="{ 'zil-sekme-aktif': sekme === 'tumu' }" @click="sekme = 'tumu'">Tümü</button>
          </div>
          <Button v-if="okunmamis.length" text @click="tumunuOku">Tümünü oku</Button>
        </div>
        <div class="max-h-96 overflow-y-auto">
          <div v-if="yukleniyor && sekme === 'tumu'" class="p-4 text-center text-sm text-gray-500">Yükleniyor…</div>
          <div v-else-if="!liste.length" class="p-4 text-center text-sm text-gray-500 dark:text-gray-400">
            {{ sekme === "okunmamis" ? "Okunmamış bildirim yok" : "Bildirim yok" }}
          </div>
          <div v-else class="divide-y divide-gray-200 dark:divide-gray-700">
            <BildirimSatiri v-for="n in liste" :key="n.id" :notif="n" sikisik @tikla="tikla" />
          </div>
        </div>
      </div>
    </Popover>
  </div>
</template>

<script>
import BildirimSatiri from "@/components/Bildirim/BildirimSatiri.vue";
import { bildirimDonustur, bildirimRotasi } from "@/services/bildirimYonlendirme";

export default {
  components: { BildirimSatiri },
  data() {
    return {
      okunmamis: [],
      tumu: [],
      sekme: "okunmamis",
      yukleniyor: false,
      zamanlayici: null,
    };
  },
  computed: {
    liste() {
      return this.sekme === "okunmamis" ? this.okunmamis : this.tumu;
    },
  },
  mounted() {
    this.okunmamisYukle();
    this.zamanlayici = setInterval(this.okunmamisYukle, 60000);
  },
  beforeUnmount() {
    clearInterval(this.zamanlayici);
  },
  methods: {
    ac(e) {
      this.$refs.pop.toggle(e);
    },
    okunmamisYukle() {
      this.$Servis("GET", "GetOkunmamisBildirimler", "")
        .then((res) => {
          this.okunmamis = res?.status === 200 && Array.isArray(res.data) ? res.data.map(bildirimDonustur) : [];
        })
        .catch(() => {});
    },
    tumunuYukle() {
      this.okunmamisYukle();
      this.yukleniyor = true;
      this.$Servis("GET", "GetBildirimler", "")
        .then((res) => {
          this.tumu = res?.status === 200 && Array.isArray(res.data) ? res.data.map(bildirimDonustur) : [];
        })
        .catch(() => { this.tumu = []; })
        .finally(() => { this.yukleniyor = false; });
    },
    okunduIsaretle(n) {
      n.read = true;
      const t = this.tumu.find((x) => x.id === n.id);
      if (t) t.read = true;
      this.okunmamis = this.okunmamis.filter((x) => x.id !== n.id);
    },
    tikla(n) {
      if (!n.read) {
        this.$Servis("POST", "SetBildirimOkundu", { Bildirim_rowid: n.id })
          .then((res) => { if (res?.status === 200) this.okunduIsaretle(n); })
          .catch(() => {});
      }
      const rota = bildirimRotasi(n, true);
      if (rota) {
        this.$refs.pop.hide();
        this.$router.push(rota);
      }
    },
    tumunuOku() {
      this.$Servis("GET", "SetTumBildirimlerOkundu", "")
        .then((res) => {
          if (res?.status === 200) {
            this.okunmamis = [];
            this.tumu.forEach((n) => (n.read = true));
          }
        })
        .catch(() => this.$toast.add({ severity: "error", summary: "Hata", detail: "Bildirimler işaretlenemedi.", life: 3000 }));
    },
  },
};
</script>

<style scoped>
.zil-sayi {
  position: absolute; top: 0.1rem; right: 0.05rem;
  min-width: 1rem; height: 1rem; padding: 0 0.25rem; border-radius: 999px;
  background: #dc2626; color: #fff; font-size: 0.625rem; font-weight: 700; line-height: 1rem; text-align: center;
}
.zil-sekme { padding: 0.25rem 0.5rem; border-radius: 0.375rem; font-size: 0.8rem; color: #4b5563; }
.zil-sekme:hover { background: #f3f4f6; }
.zil-sekme-aktif { background: #fff7ed; color: #c2410c; font-weight: 600; }
.dark .zil-sekme { color: #cbd5e1; }
.dark .zil-sekme:hover { background: #1f2937; }
.dark .zil-sekme-aktif { background: rgba(237, 122, 24, 0.15); color: #fdba74; }
</style>
